<template>
  <div
    class="screen body-2"
    :class="{ 'screen--gapless': $props.gapless, 'screen--fullWidth': $props.fullWidth }"
  >
    <div
      v-if="$slots.header"
      class="screen__header"
    >
      <div class="the-grid">
        <slot name="header" />
      </div>
    </div>
    <div class="screen__content">
      <div class="the-grid">
        <slot />
      </div>
    </div>
    <div
      v-if="$slots.footer"
      class="screen__footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script setup>
// INIT
defineProps({
  fullWidth: {
    type: Boolean,
    default: true,
  },

  gapless: {
    type: Boolean,
    default: false,
  },
})
</script>

<style scoped>
.screen {
  display: flex;
  flex-direction: column;
  margin: 0 0 var(--dotcom-responsive-spacing-res-s) 0;

  &.screen--gapless {
    .screen__header {
      padding: 0;
    }

    .screen__content {
      padding: var(--dotcom-responsive-spacing-res-s) 0 0;
    }
  }
}

.screen__content {
  padding: var(--dotcom-responsive-spacing-res-s) 0 0;
  position: relative;
  display: flex;
  align-items: center;
  min-height: 45vh;

  &:before {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    content: '';
    height: var(--dotcom-responsive-spacing-res-s);

    background-color: var(--surface-ext-b-low);
  }

  &:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    right: 0;
    height: var(--dotcom-responsive-spacing-res-s);
    border-radius: var(--border-radius-res-l) var(--border-radius-res-l) 0 0;
    background-color: var(--surface);
  }

  .the-grid {
    width: 100%;
  }
}

.screen__header {
  background-color: var(--surface-ext-b-low);
}

.screen--fullWidth .screen__header .the-grid:deep(> *),
.screen--fullWidth .screen__content .the-grid:deep(> *) {
  grid-column: 1 / -1;
}

/* Align content with navigation and center it with equal padding on both sides */
@media (--v-large) {
  .screen__content .the-grid {
    padding-left: calc(var(--dotcom-responsive-offset-responsive) + var(--dotcom-responsive-spacing-res-xxl));
    padding-right: calc(var(--dotcom-responsive-offset-responsive) + var(--dotcom-responsive-spacing-res-xxl));
  }
}
</style>
